import Loading from "@ingka/loading";
import Text from "@ingka/text";
import { lazy, Suspense } from "react";
import AppFooter from "@/components/layout/AppFooter";
import AppHeader from "@/components/layout/AppHeader";
import styles from "./DataCatalogPage.module.css";

// Swagger UI is large, so it's only downloaded when someone opens this page.
const SwaggerExplorer = lazy(
	() => import("@/components/data-catalog/SwaggerExplorer"),
);

export default function DataCatalogPage() {
	return (
		<div className={styles.page}>
			<AppHeader />
			<main className={styles.main}>
				<div className={styles.hero}>
					<Text tagName="h1" textStyle="Heading.XL">
						Data Catalog
					</Text>
					<Text tagName="p" textStyle="Body.L" className={styles.lead}>
						Browse table metadata from Databricks: catalogs, schemas, tables and
						their columns. Open an endpoint, choose <strong>Try it out</strong>,
						fill in the names and select <strong>Execute</strong>. This shows
						metadata only, never table data.
					</Text>
				</div>
				<Suspense fallback={<Loading text="Loading the Data Catalog..." />}>
					<SwaggerExplorer />
				</Suspense>
			</main>
			<AppFooter />
		</div>
	);
}
